import { createSelector } from 'reselect'
import viewPropertiesSelector from '../viewPropertiesSelector'

const displayPriceViewSwitcherSelector = createSelector(
    viewPropertiesSelector,
    (viewProperties): boolean => viewProperties && viewProperties['shoppingcart.displayPriceViewSwitcher'] === 'true',
)

export default displayPriceViewSwitcherSelector
